module.exports = __webpack_public_path__ + "static/media/msgicon.0b2ee247.svg";